import { FETCH_DATA_REQUEST, FETCH_DATA_SUCCESS, FETCH_DATA_FAILURE } from '../actions';

const initialState = {
    sections : null,
    loading  : {}, // Change from boolean to object to track multiple calls
    error    : {},
    data     : {} // Store different API responses separately
};

const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DATA_REQUEST:
            return { 
                ...state, 
                loading: { ...state.loading, [action.key]: true }, 
                error: { ...state.error, [action.key]: null } 
            };

        case FETCH_DATA_SUCCESS:
            return {
                ...state,
                loading: { ...state.loading, [action.key]: false },
                data: { ...state.data, [action.key]: action.payload },
            };

        case FETCH_DATA_FAILURE:
            return { 
                ...state, 
                loading: { ...state.loading, [action.key]: false }, 
                error: { ...state.error, [action.key]: action.payload }
            };

        default:
            return state;
    }
};

export default dataReducer;
